import { StaticPageService } from '../../Services/static-page.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-static-page',
  template: require('./static-page.component.html'),
  styles: [require('./static-page.component.css')],
  encapsulation: ViewEncapsulation.None
})

export class StaticPageComponent implements OnInit {
  
  content: string = "";
  page: string = "";

  constructor(
    private staticPageService: StaticPageService,
    private route:ActivatedRoute) { 
      
        // route.params.subscribe(p => {
        //   console.log(p);
        //   if (p['page'])
        //     this.page = "/res/"+p['page']+".html"
        //     console.log( this.page);
        //   // else
        //   //  this.page = "/static/statuten.html"
        // });
    }

  ngOnInit() {
    this.route.params.subscribe( params =>{
      this.page = "/res/"+params['page']+".html"

      this.staticPageService.getFile(this.page).subscribe( (x) =>{
        this.content = x.text();
        // console.log(this.content);
      });
    })
   

  }

  buttonPressed(){
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/static-page/static-page.component.ts